const PENDING_EMAILS_STORAGE_KEY = "pending_emails_for_seat_increase";
const PENDING_EMAILS_TIMESTAMP_KEY = "pending_emails_timestamp";

export const savePendingEmails = (emails: string[]) => {
  try {
    localStorage.setItem(PENDING_EMAILS_STORAGE_KEY, JSON.stringify(emails));
    localStorage.setItem(PENDING_EMAILS_TIMESTAMP_KEY, Date.now().toString());
  } catch (error) {
    console.warn("Failed to save pending emails to localStorage:", error);
  }
};

export const loadPendingEmails = (): string[] => {
  try {
    const emails = localStorage.getItem(PENDING_EMAILS_STORAGE_KEY);
    const timestamp = localStorage.getItem(PENDING_EMAILS_TIMESTAMP_KEY);

    if (!emails || !timestamp) {
      return [];
    }

    // Check if emails are older than 24 hours (86400000 ms)
    const isExpired = Date.now() - parseInt(timestamp) > 86400000;
    if (isExpired) {
      clearPendingEmails();
      return [];
    }

    return JSON.parse(emails);
  } catch (error) {
    console.warn("Failed to load pending emails from localStorage:", error);
    return [];
  }
};

export const clearPendingEmails = () => {
  try {
    localStorage.removeItem(PENDING_EMAILS_STORAGE_KEY);
    localStorage.removeItem(PENDING_EMAILS_TIMESTAMP_KEY);
  } catch (error) {
    console.warn("Failed to clear pending emails from localStorage:", error);
  }
};
